import { _ } from "../../../core/polyglot/polyglot.js";
import Folder from "../../../models/accounting/document/Folder.js";
import selection from "../../../models/accounting/document/selection.js";

/**
 * I am used to build the strings needed as title and subtitle
 * depending of the current type of folder and the selection
 */

/**
 * Todo: Add JSDoc comment
 */
function documentArchiveTitleBuilder() {
	const my = {};
	const that = {};

	my.currentFolder = new Folder({ isRoot: true });

	that.getTitle = function () {
		if (my.currentFolder.isRoot()) {
			return titleForRoot();
		}
		return titleForFolder();
	};

	that.getSubtitle = function () {
		if (!selection.isEmpty()) {
			return subtitleForSelection();
		}
		if (my.currentFolder.isRoot()) {
			return subtitleForRoot();
		}
		return subtitleForFolder();
	};

	that.setCurrentFolder = function (folder) {
		my.currentFolder = folder;
	};

	function titleForRoot() {
		return _("Documents");
	}

	function subtitleForRoot() {
		return _("Shared files and folders");
	}

	function titleForFolder() {
		return my.currentFolder.name();
	}

	function documentsSubtitleFor(documents) {
		if (documents === 0) {
			return "";
		}
		if (documents === 1) {
			return _("1 document");
		}
		return _("{number} documents", { number: documents });
	}

	function subDirectoriesSubtitleFor(directories) {
		if (directories === 0) {
			return "";
		}
		if (directories === 1) {
			return _("1 sub folder");
		}
		return _("{number} sub folders", { number: directories });
	}

	function subtitle(spec) {
		const documents = documentsSubtitleFor(spec.documents);
		const subDir = subDirectoriesSubtitleFor(spec.subFolders);

		if (documents && subDir) {
			return _("{documents} and {subDir}", {
				documents,
				subDir,
			});
		}

		if (!documents && !subDir) {
			return _("Folder is empty");
		}

		return documents || subDir;
	}

	function subtitleForFolder() {
		return subtitle({
			documents: my.currentFolder.numberOfDocuments(),
			subFolders: my.currentFolder.numberOfSubDirectories(),
		});
	}

	function subtitleForSelection() {
		return subtitle({
			documents: selection.numberOfDocuments(),
			subFolders: selection.numberOfSubDirectories(),
		});
	}

	return that;
}

export default documentArchiveTitleBuilder;
